import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAppStore } from "@/store";
import { ScheduleWizard } from "@/components/schedules/wizard/schedule-wizard";
import { PageHeader, Breadcrumbs } from "@/components/ui";

export const Route = createFileRoute("/_authenticated/schedules/new")({
  component: NewSchedulePage,
});

function NewSchedulePage() {
  const { t } = useTranslation("schedules");
  const orgId = useAppStore((s) => s.activeOrgId);

  if (!orgId) {
    return null;
  }

  return (
    <div className="p-8">
      <Breadcrumbs
        items={[{ label: t("title"), to: "/schedules" }, { label: t("wizard.title") }]}
      />

      <PageHeader title={t("wizard.title")} backTo="/schedules" />

      <div className="mt-6">
        <ScheduleWizard orgId={orgId} />
      </div>
    </div>
  );
}
